import { forwardRef, Ref } from 'react'
import { classNames } from 'helpers/utilities'

interface DashboardMainProps {
  className?: string
  children: React.ReactNode
}

function DashboardMain(
  { className = '', children }: DashboardMainProps,
  ref?: Ref<HTMLDivElement>
) {
  return (
    <main ref={ref} className={classNames('relative flex-1', className)}>
      {children}
    </main>
  )
}

export default forwardRef<HTMLDivElement, DashboardMainProps>(DashboardMain)
